class MultiPathSVGGroup extends Konva.Group {
    constructor(config) {
      super(config);

      this.className = 'MultiPathSVGGroup';
      
      this.config = {
          fill: 'transparent',
          stroke: '#37393B',
          strokeWidth: 1,
      };

      this.attrs.type = 'MultiPathSVGGroup';
      this.attrs.draggable = true;
      this.attrs.resizable = true;
      this.attrs.sortable = true;

      this.parseSVG(config.svgString);

      if (config.group === "29 Hand") {
        this.strokeWidth(.1);
      }

      this.fill(this.config.stroke);
    }

    parseSVG(svgString) {
        const blackStr = replaceAnyAttributeValue(replaceAnyAttributeValue(svgString, "fill", "#37393B"), "stroke", "#37393B");
        //const blackStr = replaceAnyAttributeValue(replaceAnyAttributeValue(svgString, "fill", "transparent"), "stroke", "#37393B");
        const base64Svg = removeXmlDeclaration(btoa(unescape(encodeURIComponent(blackStr))));
        const dataUrl = `data:image/svg+xml;base64,${base64Svg}`;
      
        const pathRegex = /<path\b([\s\S]*?)(?:\/>|>([\s\S]*?)<\/path>)/g;
        const matchedPaths = blackStr.match(pathRegex);
        //console.log("addSvgImage matchedPaths", matchedPaths);

        const dataRegex = /\bd=["']([\s\S]*?)["']/;
        matchedPaths.forEach((path) => {
            let matchResult = path.match(dataRegex);
            //console.log("addSvgImage matchResult", matchResult);

            let svgPath = new Konva.Path({
                data: matchResult[1],
                x: 0,
                y: 0,
                fill: "transparent",
                stroke: "#37393B",
                strokeWidth: 1,
                draggable: false,
                sortable: false,
                
                scaleX: 2,
                scaleY: 2,
            });
            //svgPath.cache();
            this.add(svgPath);   
        });

        //this.cache();
    }

    stroke(newStroke) {
        this.config.stroke = newStroke;
        this.children.forEach(item => {
            item.stroke(newStroke);
        });
    }

    strokeWidth(newStrokeWidth) {
        this.config.strokeWidth = newStrokeWidth;
        this.children.forEach(item => {
            item.strokeWidth(newStrokeWidth);
        });
    }

    fill(newFill="transparent") {
        if (!newFill) {
            newFill = "transparent";
        }

        if (newFill != "transparent") {
            newFill = this.config.stroke;
        }

        this.config.fill = newFill;
        this.children.forEach(item => {
            item.fill(newFill);
        });
    }

    getFilled() {
        return this.config.fill != "transparent";
    }

}
